import { useEffect ,useState,useRef } from 'react';
import { useDispatch, useSelector} from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { agentSliceAction } from '../../store/agentSlice';
import { chatSliceAction,sendMessage } from '../../store/chatSlice';
import { contactAttributeSliceAction } from '../../store/contactAttributeSlice';
import { contactSliceAction } from '../../store/contactSlice';
import { emailSliceAction } from '../../store/emailSlice';
import { getContactAccountName, getWrapupCode } from '../../utils/utils';
import { translateChatMessage, SendLogs, whisperAPI } from '../../utils/awsAPI';
import sound from '../../assets/audio/notification.wav';


const Softphone = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const notificationAudio = new Audio(sound);
    const chatSliceData = useSelector((state: any) => { return state.chatSlice });
    let executedAgent = false
    let ExecutedCCP = false
    const agentSnapshot = useSelector((state: any) => { return state.agentSlice.agentSnapshot })
    const agentState = agentSnapshot?.agentData?.snapshot?.agentAvailabilityState?.state;
    const isMonitoring = useSelector((state:any)=>{return state.agentSlice.isMonitoring})
    const region: string = `${process.env.REACT_APP_AWS_CCP_REGION}`;

    const [socket, setSocket] = useState<WebSocket | null>(null);
    const socketRef = useRef<WebSocket | null>(null);

    let isAudioPlaying = false;
    let audioQueue: Blob[] = [];




    const createWebSocketConnection = (contactId: string,internalID:string) => {
        const socket = new WebSocket(`wss://rrth8qh6o9.execute-api.eu-central-1.amazonaws.com/production?contactId=${contactId}`);

        socket.onopen = () => {
            console.log('WebSocket connection established');
        };

        socket.onmessage = (event) => {
            const message = JSON.parse(event.data);
            const time = Date.now();
            const date = new Date().toString();

            dispatch(chatSliceAction.addNewMessage({
                participantId: internalID,
                content: message.message,
                participantRole: "AGENT",
                epochTime: time,
                needTranslation: false,
                dateTime: date
            }));
        };

        socket.onerror = (error) => {
            console.error('WebSocket error:', error);
        };

        socket.onclose = () => {
            console.log('WebSocket connection closed');
        };

        return socket;
    };


    const closeWebSocketConnection = () => {
        if (socketRef.current) {
            console.log('Closing WebSocket connection');
            socketRef.current.close();
            socketRef.current = null;
            setSocket(null);
        }
    };












    function playNextInQueue() {
        if (audioQueue.length > 0 && !isAudioPlaying) {
            const nextBlob = audioQueue.shift()!;
            const audioUrl = URL.createObjectURL(nextBlob);
            const audio = new Audio(audioUrl);
    
            isAudioPlaying = true;
    
            audio.onended = () => {
                isAudioPlaying = false;
                URL.revokeObjectURL(audioUrl);
                playNextInQueue();
            };
    
            audio.play().catch(error => {
                console.error("Error playing audio:", error);
                isAudioPlaying = false;
                playNextInQueue();
            });
        }
    }


    if (agentState) {
        document.title = `[${agentState}] Fujitsu Connect`;
    }

    useEffect(() => {
        var containerDiv = document.getElementById("container-div");
        if (!containerDiv) throw new Error("No CCP mount point was found.");

        if (!ExecutedCCP) {
            connect.core.initCCP(containerDiv, {
                ccpUrl: `${process.env.REACT_APP_AWS_CCP_URL}`,
                loginUrl: `${process.env.REACT_APP_AWS_CCP_LOGIN_URL}`,
                region: `${process.env.REACT_APP_AWS_CCP_REGION}`,
                loginPopup: false,
                softphone: {
                    allowFramedSoftphone: true,
                    disableRingtone: false
                },
                pageOptions: {
                    enableAudioDeviceSettings: true,
                    enablePhoneTypeSettings: true
                },
                ccpAckTimeout: 5000, 
                ccpSynTimeout: 5000,
                ccpLoadTimeout: 5000
            });
            ExecutedCCP = true
            
            connect.agentApp.initApp(
                "customviews", 
                "customviews-container", 
                `${process.env.REACT_APP_AWS_CCP_SBS_URL}` + "stargate/app"
            );
        }

        const frame = containerDiv.querySelector("iframe");
        if (!frame) return console.warn("No Frame Found For CCP");

        frame.addEventListener("load", () => {
            try {
                if (!executedAgent) {
                    connect.agent((agent) => {
                        dispatch(agentSliceAction.agentSnapshot(agent.toSnapshot()))
                        dispatch(agentSliceAction.setAgentObj(agent))
                        navigate("/dashboard")
                        return;
                    })
                    executedAgent = true
                }
                navigate("/")
            } catch (e) {
                console.log(e);
            }
        });

        /* Agent Events */
        if (!executedAgent) {
            connect.agent((agent) => {
                agent.onRefresh(() => {
                    let agentData = agent.toSnapshot().getConfiguration()
                    SendLogs(agentData.username, agentData.softphoneAutoAccept, agentData.routingProfile.name, agent.getContacts().map(contact => contact.contactId), "Agent HeartBeat Event:CCP In Use")
                    dispatch(agentSliceAction.agentSnapshot(agent.toSnapshot()))
                })

                agent.onSoftphoneError((error: any) => {
                    let agentData = agent.toSnapshot().getConfiguration()
                    let AgentContact = agent.getContacts()

                    SendLogs(agentData.username, agentData.softphoneAutoAccept, agentData.routingProfile.name, agent.getContacts().map(contact => contact.contactId), error.errorType + ": " + error.errorMessage)
                    if (error.errorType === "unsupported_browser") {
                        error.errorMessage = "Unsupported browser";
                    } else if (error.errorType === "microphone_not_shared") {
                        error.errorMessage = "Microphone is not accessible";
                    } else if (error.errorType === "signalling_handshake_failure") {
                        error.errorMessage = "Signalling handshake failure";
                    } else if (error.errorType === "ice_collection_timeout") {
                        error.errorMessage = "Ice Collection Timeout";
                    } else if (error.errorType === "user_busy_error") {
                        error.errorMessage = "User busy";
                    } else if (error.errorType === "webrtc_error") {
                        error.errorMessage = "Web RTC error";
                    } else if (error.errorType === "realtime_communication_error") {
                        error.errorMessage = "Real-Time communication error";
                    }

                    dispatch(agentSliceAction.setSoftphoneError(error.errorMessage))
                    console.log("CustomCCP::onSoftphoneError Error" + error);
                })
            })
        }
        connect.contact((contact) => {
            if ((contact.getType() === 'voice' || contact.getType() === 'queue_callback')) {
                dispatch(contactSliceAction.setContactObject(contact))
            } else if (contact.getType() === 'chat' && contact?.getAttributes()?.ChannelTwo?.value !== "Email") {
                dispatch(contactSliceAction.setChatContactObject(contact))
            } else if (contact.getType() === 'chat' && contact?.getAttributes()?.ChannelTwo?.value === "Email") {
                //alert(contact.getType())
                dispatch(contactSliceAction.setEmailContactObject(contact))
            } else if (contact.getType() === 'task' && contact?.getAttributes()?.ChannelTwo?.value === "Email") {
                dispatch(contactSliceAction.setEmailContactObject(contact))
            }

            contact.onEnded( (Contact) => {
                closeWebSocketConnection();
                if (Contact.getType() === connect.ContactType.VOICE &&
                    !Contact.getAttributes().hasOwnProperty("TicketNumber") &&
                    process.env.REACT_APP_AWS_CCP_MandatoryWrap !== "0" &&
                    (![connect.ContactStateType.ERROR, connect.ContactStateType.MISSED, connect.ContactStateType.REJECTED].includes(Contact.getState().type))) {

                    connect.agent((agent) => {
                        if (agent) {
                            agent.setStatus({
                                "agentStateARN": process.env.REACT_APP_AWS_CCP_MandatoryWrapStateARN || "",
                                "type": connect.AgentStateType.NOT_ROUTABLE,
                                "name": "Forgot WrapCode"
                            }, {
                                success: () => {
                                    console.log("Agent Status Change Successfully -" + "Forgot WrapCode")
                                },
                                failure: () => {
                                    console.log("Agent Status Change Failed -" + "Forgot WrapCode")
                                }
                            })
                        }
                    })
                }
            })

            contact.onACW(()=>{
                closeWebSocketConnection();
                
                if(contact.getType() === 'voice'){
                    dispatch(agentSliceAction.setIsACW(true))
                }
            })
            

            contact.onDestroy(() => {
                closeWebSocketConnection();
                dispatch(agentSliceAction.setIsAgentMute(false))
                dispatch(agentSliceAction.setIsACW(false))
                
            })

            contact.onConnecting(() => {
                if (contact.getType() === "chat" || contact.getType() === "task") {
                    let isEmail = contact?.getAttributes()?.ChannelTwo?.value || '';
                    if (contact.getType() === "task" || isEmail) {
                        dispatch(chatSliceAction.changeNewIncomingEmail({ newIncomingEmail: true }));
                        //dispatch(chatSliceAction.changeisItEmail({isItEmail:true}));
                    }

                    if (isEmail !== "Email") {
                        if (contact.getInitialConnection().getType() !== "monitoring") {
                            //dispatch(chatSliceAction.changeisItEmail({isItEmail:false}));
                            dispatch(chatSliceAction.changeNewIncomingChat({ newIncomingChat: true }));
                            dispatch(chatSliceAction.changeNewIncomingChatMissedTimer({ newIncomingChatMissedTimer: (contact.getAttributes()?.MissedTimeout?.value) ? (contact.getAttributes()?.MissedTimeout?.value) : ("0") }));
                        }
                    }
                } else {
                    if(contact.getInitialConnection().getType() === "monitoring"){
                        dispatch(agentSliceAction.setMonitoring({isMonitoring: true}));
                    }
                }
            });

            contact.onMissed(() => {
                if (contact.getType() === 'voice' && (!contact.isInbound())) {
                    let contactDirection = "outbound"
                    let queueName = contact.getQueue().name
                    let account = getContactAccountName(queueName)
                    let wrapupCode = getWrapupCode(account, contactDirection, region)
                    let snapshotData: any = contact.toSnapshot()
                    let connection = snapshotData?.contactData?.connections.filter((connection: any) => (connection.type !== "agent"))[0]
                    let contactData: any = {}
                    contactData.contactId = contact.getContactId()
                    contactData.queueName = queueName
                    contactData.accountName = account
                    contactData.phone = connection?.endpoint?.phoneNumber ?? 'unknown'
                    contactData.contactDirection = contactDirection
                    contactData.contactType = contact.getType()
                    contactData.contactAttributes = contact.getAttributes()
                    contactData.isTicketNumberAssign = false;
                    contactData.wrapupData = (wrapupCode) ? wrapupCode : [];
                    dispatch(contactAttributeSliceAction.addContactAttributes(contactData))
                }

                if (contact.getType() === "chat" && contact?.getAttributes()?.ChannelTwo?.value !== "Email") {
                    dispatch(chatSliceAction.changeNewIncomingChat({ newIncomingChat: false }));
                    dispatch(chatSliceAction.changeIsItMissed({ isItMissed: true }));
                } else if (contact.getType() === "chat" && contact?.getAttributes()?.ChannelTwo?.value === "Email") {
                    dispatch(chatSliceAction.changeNewIncomingEmail({ NewIncomingEmail: false }));
                    dispatch(chatSliceAction.changeisEmailMissed({ isEmailMissed: true }));
                    dispatch(chatSliceAction.changeisItEmail({ isItEmail: true }));
                } else if (contact.getType() === "task" && contact?.getAttributes()?.ChannelTwo?.value === "Email") {
                    dispatch(chatSliceAction.changeNewIncomingEmail({ NewIncomingEmail: false }));
                    dispatch(chatSliceAction.changeisEmailMissed({ isEmailMissed: true }));
                    dispatch(chatSliceAction.changeisItEmail({ isItEmail: true }));
                }
            });

            contact.onConnected(async () => {

                const currentContactId = contact.contactId;
                const contactAttributes = contact.getAttributes();
                //Aquí es la razón de por qué no funciona SbS si no es con los atributos (no sé que tendríamos que cambiar para que funcione con la nueva cajita)
                if(contactAttributes["DefaultFlowForAgentUI"]) {
                    const contactflowId = contactAttributes["DefaultFlowForAgentUI"].value;
                    const customViewsIframe = document.querySelector('#customviews-container')!;
                    customViewsIframe.setAttribute('src', `${process.env.REACT_APP_AWS_CCP_SBS_URL}stargate/app?contactFlowId=${contactflowId}&currentContactId=${currentContactId}`);
                }


                if(contactAttributes?.ServiceNowLookup?.value && process.env.REACT_APP_AWS_CCP_AutoITSMlink === "1") {window.open(contactAttributes?.ServiceNowLookup?.value); }

                if (contact.getType() === 'voice' || contact.getType() === 'queue_callback') {
                    //Revisar aqui donde esta la data que necesito
                    localStorage.setItem("isOnMute", "false");
                    localStorage.setItem("isOnHold", "false");
                    let contactDirection = contact.isInbound() ? "inbound" : "outbound"
                    let queueName = contact.getInitialConnection().getType() === "monitoring" ? "Monitoring Queue" : contact.getQueue().name;
                    let account = getContactAccountName(queueName)
                    let wrapupCode = getWrapupCode(account, contactDirection, region)
                    let snapshotData: any = contact.toSnapshot()
                    let connection = snapshotData?.contactData?.connections.filter((connection: any) => (connection.type !== "agent"))[0]

                    let contactData: any = {}
                    contactData.contactId = contact.getContactId()
                    contactData.queueName = queueName
                    contactData.accountName = account
                    contactData.phone = connection?.endpoint?.phoneNumber ?? 'unknown'
                    contactData.contactDirection = contactDirection
                    contactData.contactType = contact.getType()
                    contactData.initialConnection = contact.getInitialConnection().getType()
                    contactData.contactAttributes = contact.getAttributes()
                    contactData.isTicketNumberAssign = false;
                    contactData.wrapupData = (wrapupCode) ? wrapupCode : [];
                    dispatch(contactAttributeSliceAction.addContactAttributes(contactData))
                } else if (contact.getType() === 'chat') {
                    let contactData: any = {}
                    contactData.contactId = contact.getContactId()
                    contactData.contactAttributes = contact.getAttributes()
                    contactData.isTicketNumberAssign = false;
                    let isEmail = contact?.getAttributes()?.ChannelTwo?.value || '';
                    if (isEmail === "Email") {
                        let contactDirection = contact.isInbound() ? "inbound" : "outbound"
                        let queueName = contact.getQueue().name
                        let account = getContactAccountName(queueName)
                        let wrapupCode = getWrapupCode(account, contactDirection, region)
                        contactData.queueName = queueName
                        contactData.accountName = account
                        contactData.phone = 'unknown'
                        contactData.contactDirection = contactDirection
                        contactData.contactType = 'email'
                        contactData.wrapupData = (wrapupCode) ? wrapupCode : [];
                        const cnn = contact.getAgentConnection() as connect.ChatConnection;
                        let agentChatSession = await cnn.getMediaController();
                        agentChatSession.controller.contactObject = contact
                        dispatch(emailSliceAction.createNewEmailConnection(agentChatSession));
                        dispatch(emailSliceAction.addContactAttributes(contactData))
                    } else {
                        const cnn = contact.getAgentConnection() as connect.ChatConnection;
                        const agentChatSession = await cnn.getMediaController();

                        let sysid = contactData.contactAttributes?.Conversation_Sysid?.value
                        const newSocket = createWebSocketConnection(sysid,contact.getContactId())
                        setSocket(newSocket);
                        socketRef.current = newSocket;




                        dispatch(chatSliceAction.createNewChat({ session: agentChatSession, contact: contact, participantId: contact.getContactId(), absoluteTime: Math.round(Date.now() / 1000), displayName: (contact.getAttributes()?.Name?.value) ? contact.getAttributes()?.Name?.value : "Customer", customerLanguage: (contact.getAttributes()?.Language?.value) ? contact.getAttributes()?.Language?.value : "Unknown", agentLanguage: (contact.getAttributes()?.AgentLanguage?.value) ? contact.getAttributes()?.AgentLanguage?.value : "English", account: contact.getAttributes()?.AccountName?.value, contactInfo: contact?.getAttributes(), type: (contact.getInitialConnection()?.getType() === "monitoring") ? "monitoring" : "chat" }));
                        const awsSdkResponseTranscript = await agentChatSession.getTranscript({ maxResults: 100, sortOrder: "ASCENDING" });
                        awsSdkResponseTranscript.data.Transcript.forEach(async (message: any) => {
                            if (message.Type === "EVENT") {
                                if (message.ContentType === "application/vnd.amazonaws.connect.event.participant.joined" && message.ParticipantRole === "AGENT") {
                                    var absoluteTime = new Date(message.AbsoluteTime);
                                    var absoluteTimeSeconds = absoluteTime.getTime();
                                    dispatch(chatSliceAction.changeAbsoluteTime({ chatId: agentChatSession.controller.contactId, absoluteTime: Math.round(absoluteTimeSeconds / 1000) }));
                                }
                            } else if (message.Type === "MESSAGE") {
                                if (message.ContentType === "text/plain" || message.ContentType === "text/markdown") {
                                    var date = new Date(message.AbsoluteTime);
                                    if (message.ParticipantRole === "SYSTEM" && message.DisplayName !== "BOT") {
                                        let time = Date.now();
                                        let systemMsg = "SYSTEM MESSAGE: " + message.Content;
                                        dispatch(chatSliceAction.addNewMessage({ participantId: agentChatSession.controller.contactId, content: systemMsg, participantRole: "SYSTEM", epochTime: time, needTranslation: false, dateTime: date.toString() }));
                                    } else {
                                        let msg = message.Content;
                                        let language = (contact.getAttributes()?.Language?.value) ? contact.getAttributes()?.Language?.value : "Unknown";
                                        let agentLanguage = (contact.getAttributes()?.AgentLanguage?.value) ? contact.getAttributes()?.AgentLanguage?.value : "English";
                                        let translationEnabled = (contact.getAttributes()?.TranslationEnabled?.value) ? (contact.getAttributes()?.TranslationEnabled?.value) : ("False");
                                        let translationDisabledByAgent = (contact.getAttributes()?.TranslationDisabledByAgent?.value) ? (contact.getAttributes()?.TranslationDisabledByAgent?.value) : ("False");


                                        let time = Date.now();
                                        dispatch(chatSliceAction.addNewMessage({ participantId: agentChatSession.controller.contactId, content: msg, participantRole: message.ParticipantRole, needTranslation: (language === agentLanguage || language === "Unknown" || agentLanguage === "Unknown") ? false : true, epochTime: time, dateTime: date.toString() }));
                                        
                                        
                                        
                                        
                                        
                                        
                                        if (!(language === agentLanguage || language === "Unknown" || agentLanguage === "Unknown") && (translationEnabled === "True" && translationDisabledByAgent === "False")) {
                                            let translation = await translateChatMessage(
                                                msg, 
                                                contact.getAttributes()?.Language?.value ?? "Unknown", 
                                                agentLanguage||"English", 
                                                agentChatSession.controller.contactId, 
                                                contact.getAttributes()?.AccountName?.value ?? "Unknown"
                                            );
                                            let translatedMsg = translation.translatedMessage;
                                            dispatch(chatSliceAction.changeMessage({ participantId: agentChatSession.controller.contactId, epochTime: time, originalMsg: msg, translatedMsg: translatedMsg, dateTime: date.toString() }));
                                        }
                                    }
                                }
                            } else if (message.Type === "ATTACHMENT") {
                                date = new Date(message.AbsoluteTime);
                                message.Attachments.forEach(async (att: any) => {
                                    const awsSdkResponse = await agentChatSession.downloadAttachment({ attachmentId: att.AttachmentId });
                                    var url = URL.createObjectURL(awsSdkResponse);
                                    dispatch(chatSliceAction.addNewAttachment({ participantId: agentChatSession.controller.contactId, content: message.Attachments[0].AttachmentName, participantRole: message.ParticipantRole, url: url, dateTime: date.toString() }));
                                })
                            }

                            if (chatSliceData.chats.length === 1) {
                                dispatch(chatSliceAction.changeSelectedChat({ newSelectedChat: contact.getContactId() }));
                            }
                        });


                        agentChatSession.onAutoDisconnection(
                            () => {
                                let time = Date.now();
                                let date = new Date(time)
                                dispatch(chatSliceAction.addNewMessage({ participantId: contact.getContactId(), content: "User is Disconnected because of inactivity, Chat Ended", participantRole: "SYSTEM", epochTime: time, needTranslation: false, dateTime: date.toString() }));
                                dispatch(chatSliceAction.endChat({ chatId: contact.getContactId() }))
                                dispatch(chatSliceAction.updateLastAction());
                            }
                        )


                        agentChatSession.onMessage(async (message: any) => {
                            if (message.data.Type === "MESSAGE") {
                                let time = Date.now();
                                var date = new Date(message.data.AbsoluteTime);
                                if (message.data.Content && message.data.ParticipantRole === "CUSTOMER" && (message.data.ContentType === "text/plain" || message.data.ContentType === "text/markdown")) {
                                    let msg = message.data.Content;
                                    let language = (contact.getAttributes()?.Language?.value) ? contact.getAttributes()?.Language?.value : "Unknown";
                                    let agentLanguage = (contact.getAttributes()?.AgentLanguage?.value) ? contact.getAttributes()?.AgentLanguage?.value : "English";
                                    let translationEnabled = (contact.getAttributes()?.TranslationEnabled?.value) ? (contact.getAttributes()?.TranslationEnabled?.value) : ("False");
                                    let translationDisabledByAgent = (contact.getAttributes()?.TranslationDisabledByAgent?.value) ? (contact.getAttributes()?.TranslationDisabledByAgent?.value) : ("False");
                                    let whisper = (contact.getAttributes()?.Whisper?.value) || "Unknown";
                                    console.log("whisper", whisper)









                                    if (!(language === agentLanguage || language === "Unknown" || agentLanguage === "Unknown") && (translationEnabled === "True"&& translationDisabledByAgent === "False")) {
                                                                                    
                                        let translation = await translateChatMessage(message.data.Content, contact?.getAttributes()?.Language?.value||"English", agentLanguage||"English", message.chatDetails.contactId,"CUSTOMER",contact.getAttributes().AccountName?.value);
                                        msg = translation.translatedMessage;


                                        if (whisper !== "Unknown" 
                                            && message.data.ParticipantRole !== "SYSTEM" 
                                            && message.data.ParticipantRole !== "AGENT"  
                                            && (message.data.ContentType === "text/plain" || message.data.ContentType === "text/markdown") ){
                                            try {
                                                const mp3Blob = await whisperAPI(msg, contact.getContactId(), contact.getAttributes().AccountName?.value);
                                                audioQueue.push(mp3Blob);
                                                playNextInQueue();
                                            } catch (error) {
                                                console.error("Error calling Whisper API:", error);
                                            }
                                        }
    
                                    }







                                    if (whisper === "Unknown" ){
                                    notificationAudio.play();
                                    }


                                    //Might change if monitor need the messages to be translated
                                    dispatch(chatSliceAction.addNewMessage({ participantId: message.data.ContactId, content: msg, participantRole: "CUSTOMER", epochTime: time, needTranslation: false, dateTime: date.toString() }));
                                } else if (message.data.Content && message.data.ParticipantRole === "SYSTEM" && (message.data.ContentType === "text/plain" || message.data.ContentType === "text/markdown")) {
                                    let msg = "SYSTEM MESSAGE: " + message.data.Content;
                                    notificationAudio.play();
                                    //Might change if monitor need the messages to be translated
                                    dispatch(chatSliceAction.addNewMessage({ participantId: message.data.ContactId, content: msg, participantRole: "SYSTEM", epochTime: time, needTranslation: false, dateTime: date.toString() }));
                                } else if (message.data.Content && message.data.ParticipantRole === "AGENT" && (message.data.ContentType === "text/plain" || message.data.ContentType === "text/markdown") && contact.getInitialConnection().getType() === "monitoring") {
                                    notificationAudio.play();
                                    //Might change if monitor need the messages to be translated
                                    dispatch(chatSliceAction.addNewMessage({ participantId: message.data.ContactId, content: message.data.Content, participantRole: "AGENT", epochTime: time, needTranslation: false, dateTime: date.toString() }));
                                }
                            } else if (message.data.Type === "EVENT") {
                                if (message.data.ContentType === "application/vnd.amazonaws.connect.event.participant.left"&& contact.getInitialConnection().getType() !== "monitoring") {
                                    let msg = "<AlarmUserLeft>User left the chat, this chat is now ended"
                                    let time = Date.now();
                                    var date = new Date(message.data.AbsoluteTime);
                                    dispatch(chatSliceAction.addNewMessage({ participantId: message.chatDetails.contactId, content: msg, participantRole: "SYSTEM", epochTime: time, needTranslation: false, dateTime: date.toString() }));
                                }
                                if (message.data.ContentType === "application/vnd.amazonaws.connect.event.chat.ended" || (message.data.ContentType === "application/vnd.amazonaws.connect.event.participant.left"&& contact.getInitialConnection().getType() === "monitoring")) {
                                    dispatch(chatSliceAction.endChat({ chatId: message.chatDetails.contactId }));
                                    
                                    dispatch(chatSliceAction.updateLastAction());
                                }
                            } else if (message.data.Type === "ATTACHMENT") {
                                date = new Date(message.data.AbsoluteTime);
                                if (message.data.ParticipantRole === "CUSTOMER") {
                                    message.data.Attachments.forEach(async (att: any) => {
                                        const awsSdkResponse = await agentChatSession.downloadAttachment({ attachmentId: att.AttachmentId });
                                        var url = URL.createObjectURL(awsSdkResponse);
                                        notificationAudio.play();
                                        dispatch(chatSliceAction.addNewAttachment({ participantId: message.data.ContactId, content: message.data.Attachments[0].AttachmentName, participantRole: "CUSTOMER", url: url, dateTime: date.toString() }));
                                    })
                                } else if (message.data.ParticipantRole === "AGENT" && contact.getInitialConnection().getType() === "monitoring") {
                                    message.data.Attachments.forEach(async (att: any) => {
                                        const awsSdkResponse = await agentChatSession.downloadAttachment({ attachmentId: att.AttachmentId });
                                        var url = URL.createObjectURL(awsSdkResponse);
                                        notificationAudio.play();
                                        dispatch(chatSliceAction.addNewAttachment({ participantId: message.data.ContactId, content: message.data.Attachments[0].AttachmentName, participantRole: "AGENT", url: url, dateTime: date.toString() }));
                                    })
                                }
                            }
                        });
                    }
                } else if (contact.getType() === 'task') {
                    let contactData: any = {}
                    contactData.contactId = contact.getContactId()
                    contactData.contactAttributes = contact.getAttributes()
                    contactData.isTicketNumberAssign = false;
                    let isEmail = contact?.getAttributes()?.ChannelTwo?.value || '';
                    if (isEmail === "Email") {

                        let contactDirection = "inbound"
                        let queueName = contact.getQueue().name
                        let account = getContactAccountName(queueName)
                        let wrapupCode = getWrapupCode(account, contactDirection, region)
                        contactData.queueName = queueName
                        contactData.accountName = account
                        contactData.phone = 'unknown'
                        contactData.contactDirection = contactDirection
                        contactData.contactType = 'email'
                        contactData.wrapupData = (wrapupCode) ? wrapupCode : [];

                        const cnn = contact.getAgentConnection() as connect.TaskConnection;
                        let snapshotData: any = contact.toSnapshot()
                        let connection = snapshotData?.contactData?.connections.filter((connection: any) => (connection.type === "agent"))[0]
                        let activeConnection = contact.getConnections()
                        let selectedConnection = activeConnection.filter((item: any) => { return item.connectionId === connection.connectionId })[0];
                        let agentChatSession = await cnn.getMediaController();
                        agentChatSession.controller.contactObject = contact
                        agentChatSession.controller.selectedConnection = selectedConnection
                        dispatch(emailSliceAction.createNewEmailConnection(agentChatSession));
                        dispatch(emailSliceAction.addContactAttributes(contactData))
                    }
                }
            })
        }
        )
        //if (!ExecutedCCP){
        connect.ChatSession.setGlobalConfig({
            loggerConfig: {
                logger: {
                    debug: (msg) => console.debug(msg),
                    info: (msg) => console.info(msg),
                    warn: (msg) => console.warn(msg),
                    error: (msg) => console.error(msg)
                },
                level: connect.ChatSession.LogLevel.INFO,
            },
            region: "eu-central-1",
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <div id="container-div" style={{ width: '400px', height: '400px', display: 'none' }}></div>
    )
}
export default Softphone;
